const FlagSvg = ({ size = 8 }) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth={1.5}
    stroke="currentColor"
    className={` size-${size}`}
  >
    <path
      d="M3 3.5V5M3 21.5V15.5M3 15.5L5.77009 14.8075C7.85435 14.2864 10.0562 14.5281 11.9778 15.4889L12.0856 15.5428C13.9687 16.4844 16.1224 16.7359 18.1718 16.2537L21.2861 15.5209C21.097 13.7899 21 12.0313 21 10.25C21 8.48343 21.0954 6.73914 21.2814 5.02202L18.1718 5.75369C16.1224 6.23591 13.9687 5.98435 12.0856 5.04278L11.9778 4.98892C10.0562 4.02812 7.85435 3.78641 5.77009 4.30748L3 5M3 15.5V5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FlagSvg;
